import { Component, OnInit, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { throttle } from 'rxjs/operators/throttle';

import { Constants } from '../../constants/constants';
import { DateUtil } from '../../common-app/util/date-util';
import { SharedService } from '../../common-app/service/shared.service';
import { LocalStorageService } from '../../common-app/service/local-storage.service';
import { ImageService, Base64Image } from '../../common-app/service/image.service';

import { Kvaw0500Service } from '../../service/kvaw0500.service';
import { Kvaw0510Service } from '../../service/kvaw0510.service';
import { Kvaw0520Service } from '../../service/kvaw0520.service';
import { Kvaw0600Service } from '../../service/kvaw0600.service';
import { Kvaw0500Vo, ActivityItemSelectListModel, ActivityRankSelectListModel } from '../../service/kvaw0500.vo';
import { Kvaw0510Vo, ActivityResultActualModel, CzShipmentActualModel } from '../../service/kvaw0510.vo';
import { Kvaw0520Vo } from '../../service/kvaw0520.vo';
import { Kvaw0600Vo, ActivityResultModel, CzShipmentModel, PhotoInfoModel } from '../../service/kvaw0600.vo';
import {
  Kvap0800ViewModel, ActivityItemListViewModel, PhotoInfoListViewModel, InputType, ActivityRankListViewModel,
  PhotoTagSelectListViewModel, ApiCallType, PhotoOperationFlgType
} from './kvap0800.view-model';

@Component({
  templateUrl: './kvap0800.component.html',
  providers: [Kvaw0500Service, Kvaw0510Service, Kvaw0520Service, Kvaw0600Service, ImageService],
})

export class Kvap0800Component implements OnInit {

  /** 入力区分（トグル、プルダウン、数値入力の切替用）htmlから参照する */
  inputType = InputType;

  /** 送信済日報一覧から遷移したのかどうかを判断するためのフラグ。htmlから参照する */
  isSent: boolean;

  /** 送信済日報一覧から遷移してきた場合に使用する一時保存情報のキー。htmlから参照する  */
  readonly sentReportKey: string = 'SENT_REPORT_KEY';

  /** 入力操作の終了を判定するためのフラグ。htmlから参照する */
  isOperationEnd: boolean;

  /** 日報報告のフォーム */
  reportForm: FormGroup;

  /** 日報報告のViewModel */
  vModel: Kvap0800ViewModel;

  /** 写真情報表示用のViewModel */
  vModelForPhoto: PhotoInfoListViewModel[];

  /** 一時保存情報のキー */
  autoSaveKey: string;

  /** 画面入力チェック用のオブジェクト */
  cObj: any;

  /** モーダルオブジェクト */
  confirmModal: BsModalRef;

  /** エラーメッセージ */
  errorMessage: string;

  /** API呼び出しパターン */
  private apiCallPattern: string;

  /** 前画面より渡された訪問年月日 */
  private deliveryDate: string;

  /** 画面入力チェック時のメッセージ用にFormControl名をキーとして入力項目名を保持するオブジェクト */
  private itemNames: any = {};

  /** 写真情報を共有データに保存する際のキー */
  private photoInfoKey = 'photoInfo';

  /** 一時保存用vo */
  private dispVo: Kvaw0500Vo; // 表示
  private resVo: Kvaw0510Vo; // 実績
  private lastVo: Kvaw0520Vo; // 前回
  private sendVo: Kvaw0600Vo; // 送信
  private errorResponseVo: Kvaw0600Vo; // エラー時の戻り

  /** 報告事項についてIMEで確定を押さないと送信されない事象を回避するため、DOMから直接取得し以下に保存する */
  private storeVal: string;
  private businessVal: string;
  private rivalVal: string;
  private etcVal: string;

  constructor(
    private element: ElementRef,
    private formBuilder: FormBuilder,
    private bsModalService: BsModalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
    private imageService: ImageService,
    private kvaw0500Service: Kvaw0500Service,
    private kvaw0510Service: Kvaw0510Service,
    private kvaw0520Service: Kvaw0520Service,
    private kvaw0600Service: Kvaw0600Service,
  ) { }

  ngOnInit() {
    // 前画面から送られてくるURLのqueryから、相手先コード、訪問年月日、送信済フラグ、担当外フラグを取得する。
    // 送信済日報一覧から遷移してきた場合のみ、isSent=trueが送られてくる。
    // 担当店外検索から遷移してきた場合のみ、isOutside=trueが送られてくる。
    let storeCode: string;
    let deliveryDate: string;
    let outsideFlg: boolean; // 送信済日報一覧からの遷移で担当外店舗の場合trueで連携される
    let chainCode: string;
    let chainCodeBranchNum: string;
    let kaibaCode: string;
    let isSent: boolean;
    let isOutside: boolean;
    this.activatedRoute.queryParams.subscribe(param => {
      storeCode = param['storeCode'];
      deliveryDate = param['deliveryDate'];
      this.deliveryDate = deliveryDate;
      outsideFlg = param['outsideFlg'] === 'true';
      chainCode = param['chainCode'];
      chainCodeBranchNum = param['chainCodeBranchNum'];
      kaibaCode = param['kaibaCode'];
      isSent = param['isSent'] === 'true';
      this.isSent = isSent;
      isOutside = param['isOutside'] === 'true';
    });
    // 一時保存情報のキーを生成する。
    this.setAutoSaveKey(storeCode, deliveryDate);
    // 一時保存されているかどうか判定する。
    let isSaved: boolean;
    if (isSent) {
      // 送信済日報一覧から遷移してきた場合は、一時保存情報を削除しisSavedをfalseにする。
      // autoSaveKeyは共有データ保存でも使用するのでここでは何もせず、html側でキーを固定化する。
      this.localStorageService.remove(this.sentReportKey);
      isSaved = false;
    } else {
      isSaved = this.localStorageService.load(this.autoSaveKey) ? true : false;
    }

    // 呼び出すAPIを選択する
    let obsArr: any[] = [];
    if (isOutside === true) {
      // 担当店外検索からの遷移の場合（一時保存されていても、いなくても、担当店外用のAPIを呼び出す）
      obsArr = [
        // 表示用の情報を取得
        this.searchReportDetailForDisplayObservableOutside(storeCode, deliveryDate, chainCode, chainCodeBranchNum, kaibaCode),
      ];
      this.apiCallPattern = ApiCallType.outside;
    } else if (isSaved === true) {
      // 一時保存情報のある場合
      obsArr = [
        // 表示用の情報を取得
        this.searchReportDetailForDisplayObservable(storeCode, deliveryDate),
      ];
      this.apiCallPattern = ApiCallType.saved;
    } else {
      // 一時保存情報のない（新規の）場合
      if (isSent === true) {
        // 送信済日報一覧からの遷移の場合
        if (outsideFlg) {
          // 送信済日報一覧からの遷移でかつ、担当外の場合
          obsArr = [
            // 表示用の情報を取得
            this.searchReportDetailForDisplayObservableOutside(storeCode, deliveryDate, chainCode, chainCodeBranchNum, kaibaCode),
            // 実績値を取得
            this.searchReportDetailActualObservable(storeCode, deliveryDate),
          ];
        } else {
          // 送信済日報一覧からの遷移でかつ、担当店の場合
          obsArr = [
            // 表示用の情報を取得
            this.searchReportDetailForDisplayObservable(storeCode, deliveryDate),
            // 実績値を取得
            this.searchReportDetailActualObservable(storeCode, deliveryDate),
          ];
        }
        this.apiCallPattern = ApiCallType.sent;
      } else {
        // 担当店一覧からの遷移の場合
        obsArr = [
          // 表示用の情報を取得
          this.searchReportDetailForDisplayObservable(storeCode, deliveryDate),
          // 前回値を取得
          this.searchReportDetailActualLastObservable(storeCode),
        ];
        this.apiCallPattern = ApiCallType.inCharge;
      }
    }

    // APIを呼び出す
    Observable.forkJoin(obsArr).subscribe(() => {
      /** ViewModelを生成 */
      this.buildViewModel();
      /** フォームの初期化 */
      this.buildForm();
      /** 画面入力チェック用のオブジェクトを生成 */
      this.cObj = {};
    });
  }

  /**
   * 一時保存情報のキーを生成する
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   */
  private setAutoSaveKey(storeCode: string, deliveryDate: string) {
    this.autoSaveKey = Constants.LOCAL_SAVE_KEY_GROUP_COMPANY_CODE + deliveryDate + storeCode;
  }

  /**
   * 日報詳細情報（表示用情報）を取得する（API呼出）
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   */
  private searchReportDetailForDisplayObservable(storeCode?: string, deliveryDate?: string): Observable<Kvaw0500Vo> {
    return this.kvaw0500Service.searchReportDetailForDisplay(storeCode, deliveryDate)
      .map(responseVo => {
        // 表示用に値を変換
        this.dispVo = responseVo;
        return responseVo;
      });
  }

  /**
   * 日報詳細情報（担当店外一覧から遷移した場合の表示用情報）を取得する（API呼出）
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   * @param chainCode チェーンコード
   * @param chainCodeBranchNum チェーンコード枝番
   * @param kaibaCode 買い場コード
   */
  private searchReportDetailForDisplayObservableOutside(storeCode?: string, deliveryDate?: string, chainCode?: string, chainCodeBranchNum?: string, kaibaCode?: string): Observable<Kvaw0500Vo> {
    return this.kvaw0500Service.searchReportDetailForDisplayOutside(storeCode, deliveryDate, chainCode, chainCodeBranchNum, kaibaCode)
      .map(responseVo => {
        // 表示用に値を変換
        this.dispVo = responseVo;
        return responseVo;
      });
  }

  /**
   * 日報詳細情報（実績情報）を取得する（API呼出）
   * @param storeCode 相手先コード
   * @param deliveryDate 訪問年月日
   */
  private searchReportDetailActualObservable(storeCode?: string, deliveryDate?: string): Observable<Kvaw0510Vo> {
    return this.kvaw0510Service.searchReportDetailActual(storeCode, deliveryDate)
      .map(responseVo => {
        // 表示用に値を変換
        this.resVo = responseVo;
        return responseVo;
      });
  }

  /**
   * 日報詳細情報（前回訪問時の実績情報）を取得する（API呼出）
   *  @param storeCode 相手先コード
   */
  private searchReportDetailActualLastObservable(storeCode?: string): Observable<Kvaw0520Vo> {
    return this.kvaw0520Service.searchReportDetailActualLast(storeCode)
      .map(responseVo => {
        // 表示用に値を変換
        this.lastVo = responseVo;
        return responseVo;
      });
  }

  /**
   * 日報情報を送信する（API呼出）
   *  @param reportInfoVo 日報情報VO
   */
  private registerReportInfoObservable(reportInfoVo?: Kvaw0600Vo): Observable<Kvaw0600Vo> {
    return this.kvaw0600Service.registerReportInfo(reportInfoVo)
      .map(responseVo => {
        this.errorResponseVo = responseVo;
        return responseVo;
      });
  }

  /**
   * ViewModelを生成する
   * APIで取得したVOから、画面初期表示用のViewModelを生成する
   */
  private buildViewModel() {
    const dt: string = this.getDefaultDateTime();
    this.vModel = {};
    this.vModel.activityItemList = [];
    this.vModel.activityRankList = [];
    this.vModel.photoInfoList = [];
    this.vModel.storeCode = this.dispVo.deliveryInfoDisplay.storeCode;
    this.vModel.storeName = this.dispVo.deliveryInfoDisplay.storeName;
    this.vModel.enterDateTime = dt;
    this.vModel.exitDateTime = dt;
    this.vModel.activityItemList = this.dispVo.activityResultDisplay.map(list => <ActivityItemListViewModel>{
      checked: false,
      dispText: '選択してください',
      activityResultVal: null,
      activityItemCode: list.activityItemCode,
      activityItemName: list.activityItemName,
      resultInputType: list.resultInputType,
      activityTargetType: list.activityTargetType,
      nationwideActivityType: list.nationwideActivityType,
      ratingTargetFlg: list.ratingTargetFlg,
      lastVal: list.lastVal,
      plannedVal: list.plannedVal,
      lastRating: list.lastRating,
      printSeq: list.printSeq,
      activityItemSelectList: list.activityItemSelectList.map(li => <ActivityItemSelectListModel>{
        resultInputValType: li.resultInputValType,
        resultInputValTypeName: li.resultInputValType + '：' + li.resultInputValTypeName,
      }),
    });

    this.vModel.activityRankList = this.dispVo.czShipmentDisplay;
    this.vModel.activityRankList = this.dispVo.czShipmentDisplay.map(list => <ActivityRankListViewModel>{
      checked: false,
      dispText: '',
      // 活動ランクの初期値設定を反映する。前回値／実績が存在する場合はそちらで上書きされる。
      activityRankResultVal: list.activityRankInitialSelectedVal,
      activityRankClassificationType: list.activityRankClassificationType,
      activityRankClassificationName: list.activityRankClassificationName,
      activityRankInputType: list.activityRankInputType,
      activityRankPlannedVal: list.activityRankPlannedVal,
      plannedActivityRankType: list.plannedActivityRankType,
      resultMaxValForCheck: list.resultMaxValForCheck,
      resultMinValForCheck: list.resultMinValForCheck,
      activityRankInitialSelectedVal: list.activityRankInitialSelectedVal,
      activityRankSelectList: list.activityRankSelectList.map(li => <ActivityRankSelectListModel>{
        activityRankType: li.activityRankType,
        activityRankTypeName: li.activityRankType + '：' + li.activityRankTypeName,
        resultMaxVal: li.resultMaxVal,
        resultMinVal: li.resultMinVal,
      }),
    });
    // 活動ランクの初期値設定をdispTextに反映する。
    let ind = 0;
    this.vModel.activityRankList.forEach(list => {
      this.activityRankRadioChange(ind, list.activityRankResultVal);
      ind++;
    });

    this.vModel.photoTagSelectList = this.dispVo.photoInfoDisplay.photoTagSelectList.map(list => <PhotoTagSelectListViewModel>{
      photoTagCode: list.photoTagCode,
      photoTagDisplayName: list.photoTagDisplayName,
    });
    // プレースホルダーを設定する
    this.vModel.storeFrontReportPlaceHolder = this.dispVo.reportContentDisplay.storeFrontPlaceholder;
    this.vModel.businessDiscussionReportPlaceHolder = this.dispVo.reportContentDisplay.businessDiscussionPlaceholder;
    this.vModel.rivalryInfoReportPlaceHolder = this.dispVo.reportContentDisplay.rivalryInfoPlaceholder;
    this.vModel.etcMemoReportPlaceHolder = this.dispVo.reportContentDisplay.etcMemoPlaceholder;

    // 担当店一覧からの遷移の場合は、前回値（活動項目のみ）を反映する。
    if (this.apiCallPattern === ApiCallType.inCharge) {
      let i = 0;
      this.vModel.activityItemList.forEach(list => {
        const temp = this.findActItemFromLastVo(list);
        if (temp !== null) {
          list.activityResultVal = temp;
        }
        if (list.resultInputType === InputType.select) {
          this.activityItemRadioChange(i, list.activityResultVal);
        }
        i++;
      });
      i = 0;
      this.vModel.activityRankList.forEach(list => {
        const temp = this.findActRankFromLastVo(list);
        if (temp !== null) {
          list.activityRankResultVal = temp;
        }
        if (list.activityRankInputType === InputType.select) {
          this.activityRankRadioChange(i, list.activityRankResultVal);
        }
        i++;
      });
    }

    // 送信済日報一覧からの遷移の場合は、実績値を反映する（活動項目・写真・コメント全て）。
    if (this.apiCallPattern === ApiCallType.sent) {
      this.vModel.enterDateTime = DateUtil.formatForDatetimeLocal(this.resVo.deliveryInfoActual.deliveryDate + ' ' + this.resVo.deliveryInfoActual.storeEnteringTime);
      this.vModel.exitDateTime = DateUtil.formatForDatetimeLocal(this.resVo.deliveryInfoActual.deliveryDate + ' ' + this.resVo.deliveryInfoActual.storeExitingTime);
      let i = 0;
      this.vModel.activityItemList.forEach(list => {
        const temp = this.findActItemFromResultVo(list);
        if (temp !== null) {
          list.activityResultVal = temp;
        }
        if (list.resultInputType === InputType.select) {
          this.activityItemRadioChange(i, list.activityResultVal);
        }
        i++;
      });
      i = 0;
      this.vModel.activityRankList.forEach(list => {
        const temp = this.findActRankFromResultVo(list);
        if (temp !== null) {
          list.activityRankResultVal = temp;
        }
        if (list.activityRankInputType === InputType.select) {
          this.activityRankRadioChange(i, list.activityRankResultVal);
        }
        i++;
      });
      this.vModel.photoInfoList = this.resVo.photoInfoActual.map(list => <PhotoInfoListViewModel>{
        photoCode: list.photoCode,
        imageCode: list.imageCode,
        photoFilePath: list.photoFilePath,
        imageData: '',
        photoTagCode: list.photoTagCode,
        photoTagName: list.photoTagName,
        photoOperationFlg: PhotoOperationFlgType.noChange,
      });
      this.vModel.storeFrontReportContent = this.resVo.reportContentActual.storeFrontReportContent;
      this.vModel.businessDiscussionReportContent = this.resVo.reportContentActual.businessDiscussionReportContent;
      this.vModel.rivalryInfoReportContent = this.resVo.reportContentActual.rivalryInfoReportContent;
      this.vModel.etcMemoReportContent = this.resVo.reportContentActual.etcMemoReportContent;
    }

    // 写真情報を共有データに保存、復元する（送信済日報一覧から遷移してきた場合は何もしない）
    if (!this.isSent) {
      const photoData: PhotoInfoListViewModel[] = this.sharedService.get<PhotoInfoListViewModel[]>(this.autoSaveKey + this.photoInfoKey);
      if (photoData) {
        this.vModel.photoInfoList = photoData;
      } else {
        this.sharedService.set<PhotoInfoListViewModel[]>(this.autoSaveKey + this.photoInfoKey, this.vModel.photoInfoList);
      }
    }
  }

  /**
   * 入店・退店日時に設定する初期値を取得する．
   */
  private getDefaultDateTime(): string {
    let dt: string;
    if (DateUtil.parseYYYYMMDD(this.deliveryDate).getTime() < this.getWeekStartDate(new Date()).getTime()) {
      // 前画面より渡された訪問年月日が（クライアントのシステム日付と比較して）先週だった場合、先週の月曜日をデフォルト値として設定する。
      dt = DateUtil.formatForDatetimeLocal(
        DateUtil.formatYYYYMMDD(this.getWeekStartDate(DateUtil.parseYYYYMMDD(this.deliveryDate)))
        + ' ' + DateUtil.getCurrentDate('HHmm'));
    } else {
      dt = DateUtil.formatForDatetimeLocal(this.dispVo.deliveryInfoDisplay.businessDate + ' ' + DateUtil.getCurrentDate('HHmm'));
    }
    return dt;
  }

  /**
   * 表示情報の活動項目に対応する前回値を探す
   * @param list 活動項目のViewModel
   */
  private findActItemFromLastVo(list: ActivityItemListViewModel): string {
    const temp: ActivityResultActualModel = this.lastVo.activityResultActual.find(elem => {
      return elem.activityItemCode === list.activityItemCode;
    });
    if (list.resultInputType === InputType.select) {
      if (temp && temp.activityRating) {
        return temp.activityRating;
      }
    } else if (list.resultInputType === InputType.input) {
      if (temp && temp.activityResultVal !== void 0 && temp.activityResultVal !== null) {
        return temp.activityResultVal.toString();
      }
    } else {
      if (temp && temp.activityResultVal) {
        return temp.activityResultVal.toString();
      }
    }
    return null;
  }

  /**
   * 表示情報の活動ランクに対応する前回値を探す
   * @param list 活動ランクのViewModel
   */
  private findActRankFromLastVo(list: ActivityRankListViewModel): string {
    const temp: CzShipmentActualModel = this.lastVo.czShipmentActual.find(elem => {
      return elem.activityRankClassificationType === list.activityRankClassificationType;
    });
    if (list.activityRankInputType === InputType.select) {
      if (temp && temp.activityRankType) {
        return temp.activityRankType;
      }
    } else {
      if (temp && temp.activityRankResultVal) {
        return temp.activityRankResultVal;
      }
    }
    return null;
  }

  /**
   * 表示情報の活動項目に対応する実績値を探す
   * @param list 活動項目のViewModel
   */
  private findActItemFromResultVo(list: ActivityItemListViewModel): string {
    const temp: ActivityResultActualModel = this.resVo.activityResultActual.find(elem => {
      return elem.activityItemCode === list.activityItemCode;
    });
    if (list.resultInputType === InputType.select) {
      if (temp && temp.activityRating) {
        return temp.activityRating;
      }
    } else {
      if (temp && temp.activityResultVal) {
        return temp.activityResultVal.toString();
      }
    }
    return null;
  }

  /**
   * 表示情報の活動ランクに対応する実績値を探す
   * @param list 活動ランクのViewModel
   */
  private findActRankFromResultVo(list: ActivityRankListViewModel): string {
    const temp: CzShipmentActualModel = this.resVo.czShipmentActual.find(elem => {
      return elem.activityRankClassificationType === list.activityRankClassificationType;
    });
    if (list.activityRankInputType === InputType.select) {
      if (temp && temp.activityRankType) {
        return temp.activityRankType;
      }
    } else {
      if (temp && temp.activityRankResultVal) {
        return temp.activityRankResultVal;
      }
    }
    return null;
  }

  /**
   * フォームの初期化を行う
   */
  private buildForm() {
    const group: any = {};
    group['enterDateTime'] = new FormControl(this.vModel.enterDateTime, Validators.required);
    group['exitDateTime'] = new FormControl(this.vModel.exitDateTime, Validators.required);
    let i = 0;
    this.vModel.activityItemList.forEach(actItem => {
      if (actItem.resultInputType === InputType.toggle) {
        group['switch-a-' + i] = new FormControl(this.getSwitchVal(actItem.activityResultVal), [Validators.required, Validators.pattern('[01]')]);
        this.itemNames['switch-a-' + i] = actItem.activityItemName;
      } else if (actItem.resultInputType === InputType.select) {
        const fc: FormControl = new FormControl(actItem.activityResultVal === null ? '' : actItem.activityResultVal, Validators.required);
        const index: number = i; // activityItemRadioChangeに渡すindexを固定値化する。
        fc.valueChanges.subscribe(val => { this.activityItemRadioChange(index, val); });
        group['rdo-bar-a-' + i] = fc;
        this.itemNames['rdo-bar-a-' + i] = actItem.activityItemName;
      } else if (actItem.resultInputType === InputType.input) {
        group['ipt-a-' + i] = new FormControl(actItem.activityResultVal === null || actItem.activityResultVal === '' ? '-' : actItem.activityResultVal, Validators.required);
        this.itemNames['ipt-a-' + i] = actItem.activityItemName;
      }
      i++;
    });
    i = 0;
    this.vModel.activityRankList.forEach(actRank => {
      if (actRank.activityRankInputType === InputType.toggle) {
        group['switch-b-' + i] = new FormControl(this.getSwitchVal(actRank.activityRankResultVal), [Validators.required, Validators.pattern('[01]')]);
        this.itemNames['switch-b-' + i] = actRank.activityRankClassificationName;
      } else if (actRank.activityRankInputType === InputType.select) {
        const fc: FormControl = new FormControl(actRank.activityRankResultVal === null ? '' : actRank.activityRankResultVal, Validators.required);
        const index: number = i; // activityRankRadioChangeに渡すindexを固定値化する。
        fc.valueChanges.subscribe(val => { this.activityRankRadioChange(index, val); });
        group['rdo-bar-b-' + i] = fc;
        this.itemNames['rdo-bar-b-' + i] = actRank.activityRankClassificationName;
      } else if (actRank.activityRankInputType === InputType.input) {
        group['ipt-b-' + i] = new FormControl(actRank.activityRankResultVal, Validators.required);
        this.itemNames['ipt-b-' + i] = actRank.activityRankClassificationName;
      }
      i++;
    });
    group['storeFrontReportContent'] = new FormControl(this.vModel.storeFrontReportContent);
    this.itemNames['storeFrontReportContent'] = '報告事項:店頭化';
    group['businessDiscussionReportContent'] = new FormControl(this.vModel.businessDiscussionReportContent);
    this.itemNames['businessDiscussionReportContent'] = '報告事項:商談';
    group['rivalryInfoReportContent'] = new FormControl(this.vModel.rivalryInfoReportContent);
    this.itemNames['rivalryInfoReportContent'] = '報告事項:競合情報';
    group['etcMemoReportContent'] = new FormControl(this.vModel.etcMemoReportContent);
    this.itemNames['etcMemoReportContent'] = '報告事項:その他・メモ';
    if (this.resVo) {
      group['optimisticMutex'] = new FormControl(this.resVo.deliveryInfoActual.optimisticMutex);
    } else if (this.lastVo) {
      group['optimisticMutex'] = new FormControl(this.lastVo.deliveryInfoActual.optimisticMutex);
    } else {
      group['optimisticMutex'] = new FormControl('');
    }
    group['reportInputStartDateTime'] = new FormControl(DateUtil.getCurrentDate('YYYYMMDDHHmmss'));
    this.reportForm = new FormGroup(group);
    // 写真掲載用のFormArrayを生成する
    this.createPhotoArray();
  }

  /**
   * 〇×式の入力で、0, 1 以外の値を null に変換する
   * @param val 〇×式の値
   */
  private getSwitchVal(val: string): string {
    if (val === '0' || val === '1') {
      return val;
    } else {
      return null;
    }
  }

  /**
   * 3択以上の選択式入力で、表示する初期値を設定する（活動項目用）。
   * @param index 活動項目のindex
   * @param value 実績入力値区分
   */
  private activityItemRadioChange(index: number, value: string) {
    this.vModel.activityItemList[index].dispText = '選択してください';
    if (!value || value === null || value === '') {
      // 何もしない。
    } else {
      const temp = this.vModel.activityItemList[index].activityItemSelectList.filter(val => {
        return value === val.resultInputValType;
      })[0];
      if (temp && temp.resultInputValTypeName) {
        this.vModel.activityItemList[index].dispText = temp.resultInputValTypeName;
      }
    }
  }

  /**
   * 3択以上の選択式入力で、表示する初期値を設定する（活動ランク用）。
   * @param index 活動ランクのindex
   * @param value 活動ランク区分
   */
  private activityRankRadioChange(index: number, value: string) {
    this.vModel.activityRankList[index].dispText = '選択してください';
    if (!value || value === null || value === '') {
      // 何もしない。
    } else {
      const temp = this.vModel.activityRankList[index].activityRankSelectList.filter(val => {
        return value === val.activityRankType;
      })[0];
      if (temp && temp.activityRankTypeName) {
        this.vModel.activityRankList[index].dispText = temp.activityRankTypeName;
      }
    }
  }

  /**
   * 写真掲載用のFormArrayを生成する
   */
  private createPhotoArray() {
    // 一から作り直すため一旦removeする
    this.reportForm.removeControl('photoArray');
    this.reportForm.addControl('photoArray', this.formBuilder.array([]));
    let i = 0;
    this.vModel.photoInfoList.forEach(photoInfo => {
      if (photoInfo.photoOperationFlg !== PhotoOperationFlgType.delete) {
        this.addToPhotoArray(i, photoInfo.photoTagCode);
        i++;
      }
    });
    if (i === 0) {
      this.vModelForPhoto = [];
    }
    // 共有データ情報を更新（送信済日報一覧から遷移してきた場合は何もしない）
    if (!this.isSent) {
      this.sharedService.set<PhotoInfoListViewModel[]>(this.autoSaveKey + this.photoInfoKey, this.vModel.photoInfoList);
    }
  }

  /**
   * 写真タグコードのセレクトリスト変更時の処理
   * @param index 写真のindex
   * @param photoTagCode 写真タグコード
   */
  private photoTagCodeChange(index: number, photoTagCode: string) {
    const photoTagName = this.vModel.photoTagSelectList.filter((m, n) => {
      return m.photoTagCode === photoTagCode;
    })[0].photoTagDisplayName;
    this.vModelForPhoto[index].photoTagCode = photoTagCode;
    this.vModelForPhoto[index].photoTagName = photoTagName;
    if (this.vModelForPhoto[index].photoOperationFlg === PhotoOperationFlgType.noChange) {
      this.vModelForPhoto[index].photoOperationFlg = PhotoOperationFlgType.update;
    }
    let i = 0;
    this.vModel.photoInfoList.forEach(photo => {
      if (photo.photoOperationFlg !== PhotoOperationFlgType.delete) {
        if (i === index) {
          photo.photoTagCode = photoTagCode;
          photo.photoTagName = photoTagName;
          if (photo.photoOperationFlg === PhotoOperationFlgType.noChange) {
            photo.photoOperationFlg = PhotoOperationFlgType.update;
          }
        }
        i++;
      }
    });
    // 共有データ情報を更新（送信済日報一覧から遷移してきた場合は何もしない）
    if (!this.isSent) {
      this.sharedService.set<PhotoInfoListViewModel[]>(this.autoSaveKey + this.photoInfoKey, this.vModel.photoInfoList);
    }
  }

  /**
   * 写真掲載用のFormArrayにFormControlを追加する
   * @param index FormArrayのindex
   * @param photoTagCode 写真タグコード
   */
  private addToPhotoArray(index: number, photoTagCode: string) {
    const group: any = {};
    const fc: FormControl = new FormControl(photoTagCode);
    const num: number = index; // subscribeに渡すindexを固定値化する。
    fc.valueChanges.subscribe(val => {
      this.photoTagCodeChange(num, val);
    });
    group['photoSelect-' + index] = fc;
    // 写真掲載用のFormArrayにpushするタイミングで写真表示用のViewModelを作り直す
    this.photoArray.push(new FormGroup(group));
    this.vModelForPhoto = this.vModel.photoInfoList.filter((m, n) => {
      return m.photoOperationFlg !== PhotoOperationFlgType.delete;
    });
  }

  /**
   * 写真を追加する際の処理
   * @param index 追加する写真のindex
   */
  private addEmptyPhotoItem(index: number) {
    this.vModel.photoInfoList.push({
      photoCode: '',
      imageCode: '',
      photoFilePath: '',
      imageData: '',
      photoTagCode: '',
      photoTagName: '',
      photoOperationFlg: PhotoOperationFlgType.add,
    });
    const group: any = {};
    const fc: FormControl = new FormControl('');
    const num: number = index; // subscribeに渡すindexを固定値化する。
    fc.valueChanges.subscribe(val => {
      this.photoTagCodeChange(num, val);
    });
    group['photoSelect-' + index] = fc;
    // 写真掲載用のFormArrayにpushするタイミングで写真表示用のViewModelを作り直す
    this.photoArray.push(new FormGroup(group));
    this.vModelForPhoto = this.vModel.photoInfoList.filter((m, n) => {
      return m.photoOperationFlg !== PhotoOperationFlgType.delete;
    });
  }

  /**
   * 写真掲載用のFormArrayを取得する
   */
  get photoArray(): FormArray {
    return this.reportForm.get('photoArray') as FormArray;
  }

  /**
   * 写真を削除する際の処理
   * @param index 削除する写真のindex
   */
  removeFromPhotoArray(index: number): boolean {
    // vModelForPhotoのほうは、常に物理削除となる
    const newArray = this.vModelForPhoto.filter((m, n) => n !== index);
    this.vModelForPhoto = newArray;
    // vModelのほうは、写真操作フラグを'削除'に変更する。
    // 引数のindexは、表示されている写真のindexであり、写真が削除されている場合はViewModelのindexとは一致しないので
    // ViewModelのうち写真操作フラグが'削除'となっているものを除外して走査する
    // ただし、写真操作フラグが'追加'となっている場合は新規追加分なのでViewModelから物理削除する
    let deleteFlg = false;
    let deleteIndex = 0;
    let j = 0;
    let k = 0;
    for (let i = 0; i < this.vModel.photoInfoList.length; i++) {
      const photo: PhotoInfoListViewModel = this.vModel.photoInfoList[i];
      if (photo.photoOperationFlg === PhotoOperationFlgType.delete) {
        // なにもしない
      } else {
        if (j === index) {
          if (photo.photoOperationFlg === PhotoOperationFlgType.add) {
            // もし写真操作フラグが'追加'となっている場合は新規追加分なのでViewModelから物理削除する。
            deleteFlg = true;
            deleteIndex = k;
          } else {
            // もし写真操作フラグが'追加'ではない場合はViewModelの写真操作フラグを'削除'に変更する。
            photo.photoOperationFlg = PhotoOperationFlgType.delete;
          }
          break;
        }
        j++;
      }
      k++;
    }
    if (deleteFlg) {
      const tmpArray = this.vModel.photoInfoList.filter((m, n) => n !== deleteIndex);
      this.vModel.photoInfoList = tmpArray;
    }
    // FormArrayを一から作り直す。
    this.createPhotoArray();
    return false;
  }

  /**
   * アルバムを開く際の処理
   */
  openAlbum(): boolean {
    if (this.photoArray.length > 7) {
      return false;
    }
    this.element.nativeElement.querySelector('#openFileButton').click();
    return false;
  }

  /**
   * 選択した写真をbase64に変換してViewModelに格納する
   * @param index 写真のindex
   * @param $event イベントオブジェクト
   */
  convertPhoto(index: number, $event: any) {
    if ($event.target.files && $event.target.files.length > 0) {
      let i = 0;
      let rIndex = index;
      for (let j = index; j < index + $event.target.files.length; j++) {
        if (j > 7) {
          break;
        }
        const file = $event.target.files[i];
        this.imageService.convertToBase64Format(file)
          .subscribe(base64Image => {
            if (base64Image.mimeType !== 'image/jpeg') {
              alert('JPEG形式の画像を選択してください。ファイル名：' + file.name);
              return;
            }
            this.addEmptyPhotoItem(rIndex);
            // ViewModelに値を設定する。
            this.vModelForPhoto[rIndex].imageData = base64Image.data;
            this.vModelForPhoto[rIndex].photoFilePath = file.name;
            const photoTagCode = this.photoArray.value[rIndex]['photoSelect-' + rIndex];
            this.vModelForPhoto[rIndex].photoTagCode = photoTagCode;
            let k = 0;
            this.vModel.photoInfoList.forEach(photo => {
              if (photo.photoOperationFlg !== PhotoOperationFlgType.delete) {
                if (k === rIndex) {
                  photo.imageData = base64Image.data;
                  photo.photoFilePath = file.name;
                  photo.photoTagCode = photoTagCode;
                }
                k++;
              }
            });
            rIndex++;
          });
        i++;
      }
      // FormArrayを一から作り直す。
      this.createPhotoArray();
    }
  }

  /**
   * 写真のデータをbase64からrawdataに変換する
   * @param index 写真のindex
   */
  getPhotoRawData(index: number): string {
    const base64Image: Base64Image = {
      mimeType: 'image/jpeg',
      data: this.vModelForPhoto[index].imageData,
      fileName: ''
    };
    return this.imageService.revertRawData(base64Image);
  }

  /**
   * 値入力の項目で加減算を行う
   * 小数点の加減算を整数の計算に置き換えて誤差を抑制する
   * @param orig 元の値
   * @param add 加算する値（減算する場合はマイナス値を与える）
   */
  calc(orig: number | string, add: number): number {
    const n: Number = Number(orig);
    if (n.toString().indexOf('.') > -1) {
      const as: string = (Number(add)).toString() + '00';
      return (Number.parseInt(n.toFixed(2).replace('.', '')) + Number.parseInt(as)) / Math.pow(10, 2);
    } else {
      return n.valueOf() + add;
    }
  }

  /**
   * ＋－ボタン押下時の処理（活動項目用）
   * @param index 活動項目のindex
   * @param add 加算する値（減算する場合はマイナス値を与える）
   */
  calcItem(index: number, add: number) {
    const val = this.reportForm.get('ipt-a-' + index).value;
    if (val === '-') {
      this.reportForm.get('ipt-a-' + index).patchValue('-');
    } else {
      const res = this.calc(val, add);
      this.reportForm.get('ipt-a-' + index).patchValue(res < 0 ? 0 : res);
    }
  }

  /**
   * ＋－ボタン押下時の処理（活動ランク用）
   * @param index 活動ランクのindex
   * @param add 加算する値（減算する場合はマイナス値を与える）
   */
  calcRank(index: number, add: number) {
    const val = this.reportForm.get('ipt-b-' + index).value;
    if (val === '-') {
      this.reportForm.get('ipt-b-' + index).patchValue('-');
    } else {
      const res = this.calc(val, add);
      this.reportForm.get('ipt-b-' + index).patchValue(res < 0 ? 0 : res);
    }
  }

  /**
   * 入力チェックを行う（値入力の項目）
   * @param formControlName FormControl名
   * @param max 活動ランクのチェック用実績上限値
   * @param min 活動ランクのチェック用実績下限値
   */
  inputTypeCheck(formControlName: string, max?: string, min?: string): string {
    const requiredMessage = '数値または、-を入力してください';
    const digitsItemMessage = '整数5桁、小数2桁以内の数値を入力してください';
    const digitsRankMessage = '整数10桁以内の数値を入力してください';
    const rangeMessage = `実績下限値${min}と実績上限値${max}の間で入力してください`;

    this.cObj[formControlName] = 'NG';

    const val = this.reportForm.get(formControlName).value;
    if (val === null || val === '') {
      return requiredMessage;
    } else if (val === '-') {
      this.cObj[formControlName] = null;
      return null;
    }
    try {
      const num: Number = Number(val);
      if (Number.isNaN(num.valueOf())) {
        return requiredMessage;
      }
      // 指数入力「1e2」を防止するためのチェック
      if (!/^[-0-9.]*$/.test(val) || val === '-0') {
        return requiredMessage;
      }

      if (max === undefined && min === undefined) {
        // 活動項目の場合
        if (num < 0 || num > 99999.99) {
          return digitsItemMessage;
        }
        if (num > 0 && num < 1) {
          this.reportForm.get(formControlName).patchValue(num);
        }
        const str: string = num.toString();
        if (str.length > 8) {
          return digitsItemMessage;
        } else if (str.indexOf('.') > 0) {
          const index = str.indexOf('.');
          if (str.substring(0, index).length > 6 || str.substring(index).length > 3) {
            return digitsItemMessage;
          }
        }
      } else {
        // 活動ランクの場合
        if (num < 0 || num > 9999999999) {
          return digitsRankMessage;
        }
        const str: string = num.toString();
        if (str.indexOf('.') > 0) {
          return digitsRankMessage;
        } else if (str.length > 10) {
          return digitsRankMessage;
        }
        // 活動ランクの上限、下限チェック
        const maxVal: Number = Number(max);
        const minVal: Number = Number(min);
        if (max === null || min === null || max === '' || min === '' || Number.isNaN(maxVal.valueOf()) || Number.isNaN(minVal.valueOf())) {
          this.cObj[formControlName] = null;
          return null;
        }
        if (num < minVal || num > maxVal) {
          return rangeMessage;
        }
      }
      this.cObj[formControlName] = null;
      return null;
    } catch (err) {
      return requiredMessage;
    }
  }

  /**
   * 全ての数値入力項目の入力チェックを行い、画面入力チェック用のオブジェクトを最新化する（送信チェック時に呼び出す）
   */
  private numericInputCheckAll() {
    let i = 0;
    for (const key of Object.keys(this.reportForm.controls)) {
      if (key.startsWith('ipt-a-')) {
        this.inputTypeCheck(key);
      } else if (key.startsWith('ipt-b-')) {
        this.inputTypeCheck(key, this.vModel.activityRankList[i].resultMaxValForCheck, this.vModel.activityRankList[i].resultMinValForCheck);
      }
      if (key.startsWith('ipt-b-') || key.startsWith('rdo-bar-b-') || key.startsWith('switch-b-')) {
        i++;
      }
    }
  }

  /**
   * 入力チェックを行う（写真項目）
   * @param formControlName FormControl名
   * @param index 写真のindex
   */
  photoSelectCheck(formControlName: string, index: number): string {
    const message = '写真の種類を選択してください';

    // 写真項目は増減するので、一旦写真項目のFormControlについては、全てチェックをしておく。
    let i = 0;
    for (const key in this.cObj) {
      if (key.startsWith('photoSelect-')) {
        if (i >= this.vModelForPhoto.length) {
          this.cObj[key] = null;
        } else {
          const val = this.vModelForPhoto[i].photoTagCode;
          const imageData = this.vModelForPhoto[i].imageData;
          if (imageData !== null && imageData !== '') {
            if (val === null || val === '') {
              this.cObj[key] = 'NG';
            } else {
              this.cObj[key] = null;
            }
          } else {
            this.cObj[key] = null;
          }
        }
        i++;
      }
    }
    // 自分のチェックを行う
    this.cObj[formControlName] = 'NG';
    const tagVal = this.vModelForPhoto[index].photoTagCode;
    const imgData = this.vModelForPhoto[index].imageData;
    if (imgData !== null && imgData !== '') {
      if (tagVal === null || tagVal === '') {
        return message;
      }
    }
    this.cObj[formControlName] = null;
    return null;
  }

  /**
   * 全ての写真項目の入力チェックを行い、画面入力チェック用のオブジェクトを最新化する（送信チェック時に呼び出す）
   */
  private photoSelectCheckAll() {
    let i = 0;
    this.vModelForPhoto.forEach(photo => {
      const key = 'photoSelect-' + i;
      if (photo.imageData !== null && photo.imageData !== '') {
        if (photo.photoTagCode === null || photo.photoTagCode === '') {
          this.cObj[key] = 'NG';
        } else {
          this.cObj[key] = null;
        }
      } else {
        this.cObj[key] = null;
      }
      i++;
    });
  }

  /**
   * 入力チェックを行う（テキストエリア）
   * @param formControlName FormControl名
   */
  textAreaCheck(formControlName: string): string {
    const requiredMessage = '報告事項のいずれかに入力してください';
    const characterCheckMessage = '禁止文字（「"(半角) 」）は入力できません';
    const maxLengthMessage = `500文字以内で入力してください`;

    this.cObj[formControlName] = 'NG';

    this.storeVal = this.element.nativeElement.querySelector('#storeFrontReportContent').value;
    this.businessVal = this.element.nativeElement.querySelector('#businessDiscussionReportContent').value;
    this.rivalVal = this.element.nativeElement.querySelector('#rivalryInfoReportContent').value;
    this.etcVal = this.element.nativeElement.querySelector('#etcMemoReportContent').value;

    if ((this.storeVal === null || this.storeVal === '')
      && (this.businessVal === null || this.businessVal === '')
      && (this.rivalVal === null || this.rivalVal === '')
      && (this.etcVal === null || this.etcVal === '')) {
      return requiredMessage;
    }
    let val = null;
    if (formControlName === 'storeFrontReportContent') {
      val = this.storeVal;
    } else if (formControlName === 'businessDiscussionReportContent') {
      val = this.businessVal;
    } else if (formControlName === 'rivalryInfoReportContent') {
      val = this.rivalVal;
    } else if (formControlName === 'etcMemoReportContent') {
      val = this.etcVal;
    }
    if (val !== null && val.indexOf('"') >= 0) {
      return characterCheckMessage;
    }
    if (val !== null && val.length > 500) {
      return maxLengthMessage;
    }
    this.cObj[formControlName] = null;
    return null;
  }

  /**
   * 送信時の入力チェックを行う
   */
  private isInputValid(): boolean {
    let errorMessageArray: Array<string> = [];
    this.errorMessage = '';
    // 単項目チェック（入店時刻）
    if (!this.reportForm.get('enterDateTime').valid) {
      errorMessageArray.push('入店時刻を入力してください。');
    }
    // 単項目チェック（退店時刻）
    if (!this.reportForm.get('exitDateTime').valid) {
      errorMessageArray.push('退店時刻を入力してください。');
    }
    // 入店・退店日時の範囲チェック
    const dDate: Date = DateUtil.parseYYYYMMDD(this.deliveryDate);
    const startDate: Date = this.getWeekStartDate(dDate);
    const endDate: Date = this.getWeekEndDate(dDate);
    const enter: Date = DateUtil.parseForDatetimeLocal(this.reportForm.get('enterDateTime').value);
    const exit: Date = DateUtil.parseForDatetimeLocal(this.reportForm.get('exitDateTime').value);
    if (enter < startDate || enter > endDate) {
      errorMessageArray.push('入店日は、' + DateUtil.formatYYYYMMDD(startDate) + '～' + DateUtil.formatYYYYMMDD(endDate) + 'の間で指定してください。');
    }
    if (exit < startDate || exit > endDate) {
      errorMessageArray.push('退店日は、' + DateUtil.formatYYYYMMDD(startDate) + '～' + DateUtil.formatYYYYMMDD(endDate) + 'の間で指定してください。');
    }
    // 関連チェック
    if (DateUtil.parseYYYYMMDDHHmm(this.reportForm.get('enterDateTime').value) >= DateUtil.parseYYYYMMDDHHmm(this.reportForm.get('exitDateTime').value)) {
      errorMessageArray.push('退店時刻は入店時刻よりも後の時間を指定してください。');
    }
    // 単項目チェック（Validators.required）
    if (!this.reportForm.valid) {
      for (const key in this.reportForm.controls) {
        if (key.startsWith('ipt-') || key.startsWith('rdo-') || key.startsWith('switch-')) {
          if (!this.reportForm.get(key).valid) {
            errorMessageArray.push(this.itemNames[key] + 'を確認してください。');
          }
        }
      }
    }
    // 単項目チェック（独自チェック）
    for (const key in this.cObj) {
      if (this.cObj[key] !== null) {
        if (key.startsWith('photoSelect-')) {
          errorMessageArray.push('写真情報:' + (Number(key.substring(key.length - 1)) + 1) + '番目 を確認してください。');
        } else {
          const msg: string = this.itemNames[key] + 'を確認してください。';
          if (!errorMessageArray.includes(msg)) {
            errorMessageArray.push(msg);
          }
        }
      }
    }
    // 報告事項については、メッセージをまとめる
    if (this.textAreaCheck('storeFrontReportContent') === '報告事項のいずれかに入力してください') {
      const tempArray: Array<string> = errorMessageArray.filter(ent => {
        return !ent.startsWith('報告事項:');
      });
      tempArray.push('報告事項のいずれかに入力してください。');
      errorMessageArray = tempArray;
    }
    if (errorMessageArray.length > 0) {
      this.errorMessage = errorMessageArray.join('\n');
      return false;
    }
    return true;
  }

  /**
   * 入店・退店日時の入力チェック用（週の開始日（月曜日）を」取得する）．
   * @param date 前画面より連携された小売店訪問年月日
   */
  private getWeekStartDate(date: Date): Date {
    const weekStartDate: Date = new Date(date.getTime());
    weekStartDate.setHours(0, 0);
    const e = Number(DateUtil.format(weekStartDate, 'e'));
    if (e === 1) {
      return weekStartDate;
    } else if (e === 0) {
      return DateUtil.adjustWithDays(weekStartDate, -6);
    } else {
      return DateUtil.adjustWithDays(weekStartDate, 1 - e);
    }
  }

  /**
   * 入店・退店日時の入力チェック用（週の最終日（日曜日）を」取得する）．
   * @param date 前画面より連携された小売店訪問年月日
   */
  private getWeekEndDate(date: Date): Date {
    const weekEndDate: Date = new Date(date.getTime());
    weekEndDate.setHours(23, 59);
    const e = Number(DateUtil.format(weekEndDate, 'e'));
    if (e === 0) {
      return weekEndDate;
    } else {
      return DateUtil.adjustWithDays(weekEndDate, 7 - e);
    }
  }

  /**
   * 確認用ダイアログを開く
   * @param confirm 確認用ダイアログのtemplate
   * @param inputError 入力チェックエラー用ダイアログのtemplate
   */
  openConfirm(confirm: TemplateRef<any>, inputError: TemplateRef<any>) {
    this.isOperationEnd = true;
    // 画面チェック用オブジェクト最新化のため、数値入力の独自チェック、写真エリアの関連チェック、報告事項の関連チェックを動かしておく。
    this.numericInputCheckAll();
    this.photoSelectCheckAll();
    this.textAreaCheck('storeFrontReportContent');
    this.textAreaCheck('businessDiscussionReportContent');
    this.textAreaCheck('rivalryInfoReportContent');
    this.textAreaCheck('etcMemoReportContent');
    if (this.isInputValid()) {
      this.confirmModal = this.bsModalService.show(confirm, { backdrop: 'static', class: 'modal-dialog-centered' });
    } else {
      this.confirmModal = this.bsModalService.show(inputError, { backdrop: 'static', class: 'modal-dialog-centered' });
    }
  }

  /**
   * 送信完了時のダイアログを表示する
   * @param template 送信完了（正常）時、あるいは送信エラー時のダイアログのtemplate
   */
  private showCompleteDialog(template: TemplateRef<any>) {
    // アニメーションの関係上、送信中ダイアログを消すためには500ms程度待つ必要がある。
    setTimeout(() => {
      this.confirmModal.hide();
      this.confirmModal = this.bsModalService.show(template, { backdrop: 'static', class: 'modal-dialog-centered' });
    }, 500);
  }

  /**
   * 過去日報一覧画面に遷移する。
   */
  navigateToOldReportList() {
    this.router.navigate(['/kvap0600'], {
      queryParams: {
        storeCode: this.vModel.storeCode,
      }
    });
  }

  /**
   * 送信せず戻る場合の処理
   */
  cancel() {
    this.confirmModal.hide();
  }

  /**
   * ダイアログを閉じる処理
   * @param isOk 送信成功の場合：true
   */
  close(isOk) {
    this.confirmModal.hide();
    if (isOk) {
      if (this.apiCallPattern === ApiCallType.outside) {
        this.router.navigate(['/kvap0500']);
      } else if (this.apiCallPattern === ApiCallType.sent) {
        this.router.navigate(['/kvap0400']);
      } else {
        this.router.navigate(['/kvap0302/kvap0300']);
      }
    }
  }

  /**
   * 送信処理
   * @param sending 送信中のダイアログのtemplate
   * @param complete 送信完了（正常）時のダイアログのtemplate
   * @param error 送信エラー時のダイアログのtemplate
   */
  send(sending: TemplateRef<any>, complete: TemplateRef<any>, error: TemplateRef<any>) {
    // 確認ダイアログを消す。
    this.confirmModal.hide();
    // 送信中ダイアログを表示する。
    this.confirmModal = this.bsModalService.show(sending, { backdrop: 'static', class: 'modal-dialog-centered' });
    // 送信用voを生成する。
    this.createSendVo();
    this.registerReportInfoObservable(this.sendVo).subscribe(
      (ret) => {
        if (ret.errors !== null && ret.errors.length > 0) {
          this.errorMessage = ret.errors[0].errMessage || '';
          // 送信中ダイアログを消し、送信結果ダイアログを表示する。
          this.showCompleteDialog(error);
          return;
        }
        // 今回使用した一時保存のデータを削除
        this.localStorageService.remove(this.autoSaveKey);
        if (this.isSent) {
          this.localStorageService.remove(this.sentReportKey);
        }
        // 14日前より過去の一時保存のデータを削除
        this.localStorageService.removeOldData(this.dispVo.deliveryInfoDisplay.businessDate, 14);
        // 共有データを削除
        this.sharedService.remove(this.autoSaveKey + this.photoInfoKey);
        // 送信中ダイアログを消し、送信結果ダイアログを表示する。
        this.showCompleteDialog(complete);
      },
      (err) => {
        setTimeout(() => this.confirmModal.hide(), 500);
        throw err;
      }
    );
  }

  /**
   * 送信用voを生成する
   */
  private createSendVo() {
    this.sendVo = {};
    this.sendVo.storeCode = this.vModel.storeCode;
    this.sendVo.storeName = this.vModel.storeName;
    this.sendVo.deliveryDate = this.reportForm.get('enterDateTime').value.substring(0, 10).replace(/-/g, '');
    this.sendVo.storeEnteringTime = this.reportForm.get('enterDateTime').value.substring(11).replace(':', '');
    this.sendVo.storeExitingTime = this.reportForm.get('exitDateTime').value.substring(11).replace(':', '');
    this.sendVo.keymanBusinessDiscussionType = '1';
    // 活動実績
    this.sendVo.activityResult = [];
    const itemArr = [];
    for (const key in this.reportForm.controls) {
      if (key.startsWith('ipt-a-') || key.startsWith('rdo-bar-a-') || key.startsWith('switch-a-')) {
        const index = key.substring(key.lastIndexOf('-') + 1);

        let value: string = this.reportForm.get(key).value;
        if (key.startsWith('switch-a-')) {
          value = value ? '1' : '0';
        } else if (key.startsWith('ipt-a-') && value === '-') {
          // 数値項目で、未入力の場合は、nullとして送信する
          value = null;
        }

        itemArr.push({ index: index, value: value, });
      }
    }
    itemArr.sort((a, b) => {
      return Number(a['index']) - Number(b['index']);
    });
    let i = 0;
    this.sendVo.activityResult = this.vModel.activityItemList.map(item => <ActivityResultModel>{
      activityItemCode: item.activityItemCode,
      activityRating: item.resultInputType === InputType.select ? itemArr[i++]['value'] : '',
      activityResultVal: (item.resultInputType !== null && item.resultInputType !== InputType.select) ? itemArr[i++]['value'] : null,
      plannedVal: item.plannedVal,
      printSeq: item.printSeq,
    });
    // CZ配荷
    this.sendVo.czShipment = [];
    const rankArr = [];
    for (const key in this.reportForm.controls) {
      if (key.startsWith('ipt-b-') || key.startsWith('rdo-bar-b-') || key.startsWith('switch-b-')) {
        const index = key.substring(key.lastIndexOf('-') + 1);
        rankArr.push({ index: index, value: this.reportForm.get(key).value });
      }
    }
    rankArr.sort((a, b) => {
      return Number(a['index']) - Number(b['index']);
    });
    let j = 0;
    this.sendVo.czShipment = this.vModel.activityRankList.map(rank => <CzShipmentModel>{
      activityRankClassificationType: rank.activityRankClassificationType,
      activityRankType: rank.activityRankInputType === InputType.select ? rankArr[j++]['value'] : '',
      activityRankResultVal: (rank.activityRankInputType !== null && rank.activityRankInputType !== InputType.select) ? rankArr[j++]['value'] : '',
    });
    // 写真情報
    this.sendVo.photoInfo = [];
    // 写真情報を設定する
    this.setPhotoInfo();
    // 報告内容
    this.sendVo.reportContent = {};
    this.sendVo.reportContent.businessDiscussionReportContent = this.businessVal;
    this.sendVo.reportContent.etcMemoReportContent = this.etcVal;
    this.sendVo.reportContent.rivalryInfoReportContent = this.rivalVal;
    this.sendVo.reportContent.storeFrontReportContent = this.storeVal;
    this.sendVo.optimisticMutex = this.reportForm.get('optimisticMutex').value;
    this.sendVo.reportInputStartDateTime = this.reportForm.get('reportInputStartDateTime').value;
  }

  /**
   * 写真情報を設定する
   */
  setPhotoInfo() {
    // APIで取得した写真コードが一つでもあればその写真コードを使う
    // APIで取得した写真コードが一つもなければ写真コードは空となる
    const ft = this.vModel.photoInfoList.find(list => {
      return list.photoCode !== null && list.photoCode !== '';
    });
    if (ft) {
      this.vModel.photoInfoList.forEach(list => {
        list.photoCode = ft.photoCode;
      });
    }
    // 画像コードのフォーマットは数値文字二桁（01, 02,.., 09, 10, 11,..., 98, 99）
    const imageCodeList = [];
    let max = 0;
    this.vModel.photoInfoList.forEach(list => {
      if (list.imageCode !== null && list.imageCode !== '') {
        const num: number = Number(list.imageCode.startsWith('0') ? list.imageCode.substring(1) : list.imageCode).valueOf();
        imageCodeList.push(num);
        if (max < num) {
          max = num;
        }
      }
    });
    this.vModel.photoInfoList.forEach(list => {
      if ((list.imageData === null || list.imageData === '') && (list.photoFilePath === null || list.photoFilePath === '')) {
        return;
      }
      if (list.imageCode === null || list.imageCode === '') {
        for (let i = 0; i < 100; i++) {
          max = (max + 1) > 99 ? 1 : max + 1;
          if (imageCodeList.includes(max)) {
            continue;
          } else {
            imageCodeList.push(max);
            break;
          }
        }
        const code = max.toString().length === 1 ? '0' + max.toString() : max.toString();
        list.imageCode = code;
      }
    });
    this.sendVo.photoInfo = this.vModel.photoInfoList.map(pi => <PhotoInfoModel>{
      photoCode: pi.photoCode,
      imageCode: pi.imageCode,
      imageData: pi.imageData,
      fileName: this.getFileName(pi.photoFilePath),
      photoTagCode: pi.photoTagCode,
      photoTagName: pi.photoTagName,
      photoOperationFlg: pi.photoOperationFlg,
    }).filter((m, n) => {
      return !((m.imageData === null || m.imageData === '') && (m.fileName === null || m.fileName === ''));
    });
  }

  /**
   * ファイルパスからファイル名を取得する。
   * @param path ファイルパス
   */
  getFileName(path: string): string {
    if (path === null || path === '') {
      return path;
    }
    if (path.indexOf('\\') > -1 || path.indexOf('/') > -1) {
      const fpath = path.replace(/\\/g, '/');
      if (fpath.endsWith('/')) {
        return '';
      } else {
        return fpath.substring(fpath.lastIndexOf('/') + 1);
      }
    }
    return path;
  }
}



// WEBPACK FOOTER //
// ./src/app/component/kvap0800/kvap0800.component.ts